import { Hue } from "ipctg-inflow-types/InFlowThemes"
import {
  Popover,
  PopoverProps,
  Menu as RACMenu,
  MenuItem as RACMenuItem,
  MenuItemProps as RACMenuItemProps,
  MenuProps as RACMenuProps,
} from "react-aria-components"

import { cn } from "@/utilities/etc"

import styles from "./Menu.module.css"

interface MenuProps<T extends object>
  extends RACMenuProps<T>,
    React.RefAttributes<HTMLDivElement> {
  placement?: PopoverProps["placement"]
}

const Menu = <T extends object>(props: MenuProps<T>) => {
  return (
    <Popover
      className={styles.popover}
      placement={props.placement || "bottom right"}
    >
      <RACMenu {...props} className={cn(props.className, styles.menu)}>
        {props.children}
      </RACMenu>
    </Popover>
  )
}

interface MenuItemProps<T extends object>
  extends RACMenuItemProps<T>,
    React.RefAttributes<T> {
  hue?: Extract<Hue, "primary" | "danger">
}

Menu.Item = <T extends HTMLDivElement>(props: MenuItemProps<T>) => {
  console.log("HUE:", props.hue)
  return (
    <RACMenuItem
      {...props}
      className={cn(props.className, styles.menuItem)}
      data-hue={props.hue || "primary"}
    >
      {props.children}
    </RACMenuItem>
  )
}

export default Menu
